/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import { Select, MenuItem } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
export default function Users(props) {
  const { api } = useContext(FirebaseContext);
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
    createOpenfireUser,
  } = api;
  const [state, setState] = useState({
    userType: "doctor",
    firstName: "",
    lastName: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [data, setData] = useState([]);
  const [practices, setPractices] = useState({});
  const usersdata = useSelector((state) => state.usersdata);
  const practicetypes = useSelector((state) => state.practicetypes);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const doctortypes = useSelector((state) => state.doctortypes.doctortypes);
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState({});
  const [doctorTypes, setDoctorTypes] = useState(null);
  const [bankTypes, setbankTypes] = useState([]);
const navigate = useNavigate();
  useEffect(() => {
    if (usersdata.users) {
      setData(
        usersdata.users.filter(
          (user) =>
            user.userType === "doctor" &&
            user.practiceNumber === auth.info.profile.practiceNumber
        )
      );
    } else {
      setData(usersdata.users);
    }
  }, [usersdata.users, auth.info.profile.userType, auth.info.uid]);

  useEffect(() => {
    if (bankTypes) {
      let arr = {
        savings: "Savings",
        check: "Check",
        debit: "Debit",
        credit: "Credit",
      };

      for (let i = 0; i < bankTypes.length; i++) {
        arr.push({
          label: bankTypes[i],
          value: bankTypes[i],
        });
      }
      setbankTypes(arr);
    }
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }
      console.log('specs', obj)
      setSpecialityTypes(obj);
    }
    if (doctortypes) {
      let arr = {};
      for (let i = 0; i < doctortypes.length; i++) {
        doctortypes.map((doctypes) => (arr[doctypes] = doctypes));
      }
      setDoctorTypes(arr);
    }
  }, []);
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };
  const handleBankType = (event) => {
    setState({ ...state, bankType: event.target.value });
  };

  const columns = [
    { header: language.first_name, accessorKey: "firstName", initialEditValue: "" },
    { header: language.last_name, accessorKey: "lastName", initialEditValue: "" },
    { header: "Identity Number", accessorKey: "identityNumber", initialEditValue: "" },
    {
      header: "Practice Name",
      accessorKey: "practiceName",
      initialEditValue: "",
      editable: "onEdit",
      render: (rowData) =>
        auth.info.profile.practiceName
          ? rowData.practiceName
          : auth.info.profile.practiceName,
    },
    {
      header: "Practice Licence Number",
      accessorKey: "practiceLicenseNumber",
      initialEditValue: "",
    },
    {
      header: language.email,
      accessorKey: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
    },
    {
      header: language.mobile,
      accessorKey: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },
    { header: "Password", accessorKey: "password", initialEditValue: "" },

    { header: "Doctor Type", accessorKey: "doctorType", lookup: doctorTypes },
    {
      header: "Department",
      accessorKey: "specialityType",
      lookup: specialityTypes,
    },

    {
      header: language.profile_image,
      accessorKey: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 50, borderRadius: "50%" }}
          />
        ) : null,
      editable: "never",
    },
    {
      header: "License Image",
      accessorKey: "licenseImage",
      render: (rowData) =>
        rowData.licenseImage ? (
          <img
            alt="License"
            src={rowData.licenseImage}
            style={{ width: 100 }}
          />
        ) : null,
      editable: "never",
    },
    {
      header: "Doctor Image",
      accessorKey: "doctorImage",
      render: (rowData) =>
        rowData.doctorImage ? (
          <img
            alt="doctorImage"
            src={rowData.doctorImage}
            style={{ width: 100 }}
          />
        ) : null,
      editable: "never",
    },

    { header: language.bankName, accessorKey: "bankName", initialEditValue: "" },
    { header: language.bankCode, accessorKey: "bankCode", initialEditValue: "" },
    { header: language.bankAccount, accessorKey: "bankAccount", initialEditValue: "" },
    {
      header: language.bankType,
      accessorKey: "bankType",
      lookup: bankTypes,
      editable: "onAdd",
    },
    {
      header: "Private Practice",
      accessorKey: "privatePractice",
      type: "boolean",
      initialEditValue: true,
    },
    {
      header: language.account_approve,
      accessorKey: "doctorActiveStatus",
      type: "boolean",
      initialEditValue: true,
    },
    {
      header: language.referralId,
      accessorKey: "referralId",
      editable: "never",
      initialEditValue: "",
    },
    //{ title: language.queue,  field: 'queue', type:'boolean', initialEditValue: false },
  ];


  const   onRowAdd= (newData) =>{
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.users && res.users.length > 0) {
                    alert(language.user_exists);
                    reject();
                  } else if (res.error) {
                    alert(language.email_or_mobile_issue);
                    reject();
                  } else {
                    newData["isIndependent"] = false;
                    newData["createdByAdmin"] = true;
                    newData["userType"] = "doctor";
                    newData["username"] =
                      newData.firstName.toLowerCase() +
                      newData.lastName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    setState({
                      ...state,
                      newData,
                    });
                    newData["createdAt"] = new Date().toISOString();
                    newData["referralId"] =
                      newData.firstName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    setState({
                      ...state,
                      newData,
                    });
                    let role = auth.info.profile.userType;
                    if (role === "practiceadmin") {
                      newData["practiceadmin"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "nurse") {
                      newData["nurse"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "doctor") {
                      newData["doctor"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    }
                    emailSignUp(newData).then((res) => {
                      resolve();
                      console.log("i am the back data", res);
                      if (res.uid) {
                        // dispatch(
                        //   createOpenfireUser(
                        //     newData.username,
                        //     newData.password,
                        //     newData.firstName,
                        //     newData.lastName,
                        //     newData.email
                        //   )
                        // );
                        setTimeout(() => {
                          setCommonAlert({
                            open: true,
                            msg: language.account_create_successfully,
                          });

                          navigate("/login");
                          console.log(newData);
                        }, 3000);
                      } else {
                        setCommonAlert({
                          open: true,
                          msg: language.reg_error,
                        });
                      }
                    });
                  }
                });
              }, 600);
            })
            };


  const  onRowUpdate= (newData, oldData) =>{
            new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, newData));
              }, 600);
            })
          };


  const  onRowDelete= (oldData) =>{
                    dispatch(deleteUser(oldData.id));
        };

  return data.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>

  );
}

